var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeStorageService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 137.859,
    viewBox: "0 0 250 137.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(-987.583 -394.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(1002.168 427.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M1021.891,468.484h-15.074V451.233l6.313-12.892h8.761Z",
    transform: "translate(-1006.816 -438.342)",
    fill: "#f9c05d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M1024.891,468.484h-15.074V451.233l6.313-12.892h8.761Z",
    transform: "translate(-1007.541 -438.342)",
    fill: "#996b28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 2.275,
    height: 17.251,
    transform: "translate(0 12.892)",
    fill: "#b58443"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(987.582 457.803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 24.171,
    height: 72.251,
    transform: "translate(6.128 2.194)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 55.509,
    height: 72.251,
    transform: "translate(30.3 2.194)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 55.509,
    height: 4.491,
    transform: "translate(30.3 2.194)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 24.171,
    height: 4.491,
    transform: "translate(6.128 2.194)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 88.773,
    height: 3.628,
    fill: "#e5b267"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 58.474,
    height: 3.628,
    transform: "translate(30.3)",
    fill: "#f9c05d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 10.122,
    height: 20.777,
    transform: "translate(35.14 12.389)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 41.336,
    height: 20.777,
    transform: "translate(39.669 12.389)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 10.122,
    height: 20.777,
    transform: "translate(35.14 38.494)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 41.336,
    height: 20.777,
    transform: "translate(39.669 38.494)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 3.33,
    cy: 3.33,
    r: 3.33,
    transform: "translate(52.564 45.686)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    cx: 3.33,
    cy: 3.33,
    r: 3.33,
    transform: "translate(52.564 19.315)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(1014.104 417.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    transform: "translate(23.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 0.797,
    height: 40.145,
    fill: "#6f38d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(6.936)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 2.434,
    height: 40.145,
    fill: "#9750ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(0.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 6.451,
    height: 40.145,
    fill: "#bd79ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(1.998 28.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_542",
    "data-name": "Ellipse 542",
    cx: 2.024,
    cy: 2.024,
    r: 2.024,
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(0.633 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M1060.405,465.354a1.391,1.391,0,1,1-1.391-1.392A1.391,1.391,0,0,1,1060.405,465.354Z",
    transform: "translate(-1057.623 -463.962)",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(1.518 6.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 5.009,
    height: 19.327,
    fill: "#dcdcde"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(1.518 2.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 5.009,
    height: 3.439,
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(15.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 0.797,
    height: 40.145,
    fill: "#282f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(7.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 0.797,
    height: 40.145,
    fill: "#282f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(0.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 6.451,
    height: 40.145,
    fill: "#4551a3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(1.998 28.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_543",
    "data-name": "Ellipse 543",
    cx: 2.024,
    cy: 2.024,
    r: 2.024,
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(0.632 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M1049.873,465.354a1.392,1.392,0,1,1-1.392-1.392A1.392,1.392,0,0,1,1049.873,465.354Z",
    transform: "translate(-1047.09 -463.962)",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(1.518 6.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 5.009,
    height: 19.327,
    fill: "#b8bcd9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(1.518 2.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 5.009,
    height: 3.439,
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(7.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 0.797,
    height: 40.145,
    fill: "#572680"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(7.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 0.797,
    height: 40.145,
    fill: "#572680"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(0.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 6.451,
    height: 40.145,
    fill: "#733ba8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    transform: "translate(1.998 28.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_544",
    "data-name": "Ellipse 544",
    cx: 2.024,
    cy: 2.024,
    r: 2.024,
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(0.633 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M1039.34,465.354a1.391,1.391,0,1,1-1.392-1.392A1.392,1.392,0,0,1,1039.34,465.354Z",
    transform: "translate(-1036.558 -463.962)",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(1.518 6.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 5.009,
    height: 19.327,
    fill: "#c7d8d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(1.518 2.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    width: 5.009,
    height: 3.439,
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    width: 0.797,
    height: 40.145,
    fill: "#532db2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(7.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    width: 0.797,
    height: 40.145,
    fill: "#532db2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(0.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 6.451,
    height: 40.145,
    fill: "#6f38d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(1.998 28.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_545",
    "data-name": "Ellipse 545",
    cx: 2.024,
    cy: 2.024,
    r: 2.024,
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(0.633 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M1028.807,465.354a1.391,1.391,0,1,1-1.391-1.392A1.391,1.391,0,0,1,1028.807,465.354Z",
    transform: "translate(-1026.025 -463.962)",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(1.518 6.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 5.009,
    height: 19.327,
    fill: "#b8bcd9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(1.518 2.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 5.009,
    height: 3.439,
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    d: "M0,0H15.026a1.939,1.939,0,0,1,1.939,1.939V40.145a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(32.809)",
    fill: "#bd79ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(1057.4 394.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(99.77 61.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    width: 80.413,
    height: 59.975,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_746",
    "data-name": "Rectangle 746",
    width: 24.714,
    height: 59.975,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 10.89,
    height: 4.469,
    transform: "translate(61.611 48.698)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 4.469,
    height: 4.469,
    transform: "translate(31.854 48.698)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_749",
    "data-name": "Rectangle 749",
    width: 4.469,
    height: 4.469,
    transform: "translate(37.972 48.698)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(0 61.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 80.413,
    height: 59.975,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    width: 24.714,
    height: 59.975,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 10.89,
    height: 4.469,
    transform: "translate(61.611 48.698)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 4.469,
    height: 4.469,
    transform: "translate(31.854 48.698)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 4.469,
    height: 4.469,
    transform: "translate(37.972 48.698)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(35.305 61.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 80.413,
    height: 59.975,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 24.714,
    height: 59.975,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 10.89,
    height: 4.469,
    transform: "translate(61.611 48.698)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 4.469,
    height: 4.469,
    transform: "translate(31.854 48.698)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 4.469,
    height: 4.469,
    transform: "translate(37.972 48.698)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(105.837 14.023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 61.611,
    height: 45.952,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 18.935,
    height: 45.952,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 8.127,
    height: 4.469,
    transform: "translate(46.79 34.675)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 4.469,
    height: 4.469,
    transform: "translate(26.546 34.675)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 4.469,
    height: 4.469,
    transform: "translate(32.664 34.675)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(0 16.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 80.413,
    height: 43.782,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 24.714,
    height: 43.782,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 10.89,
    height: 4.469,
    transform: "translate(61.611 32.505)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 4.469,
    height: 4.469,
    transform: "translate(31.854 32.505)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 4.469,
    height: 4.469,
    transform: "translate(37.972 32.505)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(35.305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 80.413,
    height: 59.975,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 24.714,
    height: 59.975,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 10.89,
    height: 4.469,
    transform: "translate(61.611 48.698)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 4.469,
    height: 4.469,
    transform: "translate(31.854 48.698)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 4.469,
    height: 4.469,
    transform: "translate(37.972 48.698)",
    fill: "#a55927"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(2.112 122.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 174.099,
    height: 3.531,
    transform: "translate(1.223)",
    fill: "#f9c05d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 57.773,
    height: 3.531,
    fill: "#fccc8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 16.442,
    height: 11.726,
    transform: "translate(1.223 3.531)",
    fill: "#b26e14"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 6.935,
    height: 11.726,
    transform: "translate(1.223 3.531)",
    fill: "#e5b267"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 20.174,
    height: 11.726,
    transform: "translate(22.028 3.531)",
    fill: "#b26e14"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 8.509,
    height: 11.726,
    transform: "translate(22.028 3.531)",
    fill: "#e5b267"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 125.061,
    height: 11.726,
    transform: "translate(49.264 3.531)",
    fill: "#b26e14"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 8.509,
    height: 11.726,
    transform: "translate(49.264 3.531)",
    fill: "#e5b267"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeStorageService);
export default __webpack_public_path__ + "static/media/free-storage-service.e9299e75120eae69049be6e82088721c.svg";
export { ForwardRef as ReactComponent };